import React, { useState } from 'react';

import CrownIconImg from "images/crown_icon.png";
import appInfoContainer from 'auth/appInfoContainer';
import { replaceTextURLToLink } from 'utils/utils.js';
import { GroupDetailSection, Title, Description, DescriptionSummary, ShowMoreBtnWrapper, 
    ShowMoreBtn, ProfileLink, ProfileImg, Btnlist,Btn, BtnNum, Num, Userpf, Userimg, CrownIcon, 
    Crowntit, Name } from './style';

export default function GroupDetailInfo({userInfo,groupInfo,fontsize,no,userImg}) {
    const [showDescription ,setShowDescription] = useState(true); 

    let adminUserNo = (groupInfo.admins) ? groupInfo.admins[0].user_no : null;
    const todoUrl = () => {
        if(groupInfo.admins && userInfo.id == groupInfo.admins[0].user_no)
            return "/task/list";
        else 
            return `/task/friend/${adminUserNo}/list`;
    }
    let description =null;
    if(groupInfo.description)
    {
        description = replaceTextURLToLink(groupInfo.description);
    }
    
    let userProfileTag = [];
    if(userImg && userImg !== "")
    {
        userProfileTag.push(<ProfileImg key="group-project-user-profile-img" 
                                src={appInfoContainer.imagePath +"/user_profile_img/"+userImg}
                            />);
    }

    const handleClickShowMoreBtn = (e) => {
        if(showDescription === false)
        {
            setShowDescription(true);
        }
        else
        {
            setShowDescription(false);
        }
    }
    return(
        <GroupDetailSection>
            <Title>{groupInfo.title}</Title>
            <Userpf>
                {
                    userInfo.isLogin ? 
                    <ProfileLink 
                        component={Userimg} 
                        to={() => {return `${todoUrl()}`}} >
                        {userProfileTag}
                    </ProfileLink>
                    :
                    <Userimg>{userProfileTag}</Userimg>
                }
                
                <CrownIcon><img src={CrownIconImg}/></CrownIcon>
                {
                    groupInfo.admins ?
                    <Name>{groupInfo.admins[0].nickname}</Name>
                    :
                    null
                }
                <Crowntit>| 모임장</Crowntit>
            </Userpf>
            {
                (showDescription === true)
                    ?(<Description fontsize={fontsize} >{description}</Description>)
                    :(<DescriptionSummary fontsize={fontsize}>{description}</DescriptionSummary>)
            }
            
            <ShowMoreBtnWrapper>
                <ShowMoreBtn onClick={handleClickShowMoreBtn}>{(showDescription === true)?'간략히':'더보기'}</ShowMoreBtn>
            </ShowMoreBtnWrapper>
            <Btnlist>
                <Btn to={`/group/menber/list/${no}`}>참여인원<Num>{groupInfo.member_num}</Num></Btn>
            </Btnlist>
        </GroupDetailSection>
    );
}
